let uidCounter = 0;

const BaseCheckbox = {
    template: '#checkbox-template',
    model: {
        prop: 'modelValue',
        event: 'input'
    },
    emits: ['input', 'update:modelValue'],
    props: {
        id: {
            type: String,
            default: function () {
                return 'checkbox-id-' + (uidCounter++);
            }
        },
        name: {
            type: String,
            default: null
        },
        value: {
            default: null
        },
        modelValue: {
            default: undefined
        },
        className: {
            type: String,
            default: null
        },
        checked: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        model: {}
    },
    computed: {
        state: function() {
            if (this.modelValue === undefined) {
                return this.checked;
            }
            if (Array.isArray(this.modelValue)) {
                return this.modelValue.indexOf(this.value) > -1;
            }
            return !!this.modelValue;
        }
    },
    methods: {
        onChange: function() {
            this.toggle();
        },
        toggle: function() {
            let value;
            if (Array.isArray(this.modelValue)) {
                value = this.modelValue.slice(0);
                if (this.state) {
                    value.splice(value.indexOf(this.value), 1);
                } else {
                    value.push(this.value);
                }
            } else {
                value = !this.state;
            }
            this.$emit('input', value);
            this.$emit('update:modelValue', value);
        }
    },
    watch: {
        checked: function(newValue) {
            if (newValue !== this.state) {
                this.toggle();
            }
        }
    },
    mounted: function() {
        if (this.checked && !this.state) {
            this.toggle();
        }
    },
};

const BaseRadio = {
    template: '#radio-template',
    model: {
        prop: 'modelValue',
        event: 'input'
    },
    emits: ['input', 'update:modelValue'],
    props: {
        id: {
            type: String,
            default: function () {
                return 'radio-id-' + (uidCounter++);
            },
        },
        name: {
            type: String,
            default: null
        },
        value: {
            default: null
        },
        modelValue: {
            default: undefined
        },
        className: {
            type: String,
            default: null
        },
        checked: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        model: {}
    },
    computed: {
        state: function () {
            if (this.modelValue === undefined) {
                return this.checked;
            }

            return this.value === this.modelValue;
        }
    },
    methods: {
        onChange: function () {
            this.toggle();
        },
        toggle: function () {
            this.$emit('input', this.value);
            this.$emit('update:modelValue', this.value);
        }
    },
    watch: {
        checked: function (newValue) {
            if (newValue !== this.state) {
                this.toggle();
            }
        }
    },
    mounted: function () {
        if (this.checked && !this.state) {
            this.toggle();
        }
    },
};

if (typeof module !== 'undefined') {
    module.exports = { BaseCheckbox: BaseCheckbox, BaseRadio: BaseRadio };
}
